import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ";
function OwnerAttendanceVerification() {
    const userId =
        localStorage.getItem(
            "user_id"
        );
    const [
        ownerId,
        setOwnerId
    ] = useState(null);
    const [
        requirements,
        setRequirements
    ] = useState([]);
    const [
        selectedRequirement,
        setSelectedRequirement
    ] = useState(null);
    const [
        attendance,
        setAttendance
    ] = useState([]);
    const [showAttendanceModal, setShowAttendanceModal] = useState(false);
    // ---------------- OWNER ----------------
    useEffect(() => {
        axios.get(
            baseUrl +
            "landowner-profile/" +
            userId +
            "/"
        )
            .then((res) => {
                if (
                    res.data.length > 0
                ) {
                    setOwnerId(
                        res.data[0].id
                    );
                }
            });
        console.log(attendance);
    }, [userId]);
    // ---------------- REQUIREMENTS ----------------
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = () => {
        axios.get(baseUrl + "landowner-req/")
            .then(res => {
                setRequirements(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    // ---------------- ATTENDANCE ----------------
    const fetchAttendance =
        async (
            requirementId
        ) => {
            try {
                const res =
                    await axios.get(
                        baseUrl +
                        "requirement-attendance/" +
                        requirementId +
                        "/"
                    );
                setAttendance(
                    res.data
                );
            } catch (err) {
                console.log(err);
            }
        };
    // ---------------- VERIFY ----------------
    const verifyAttendance = async (attendance) => {
        try {
            // 1. Verify attendance
            await axios.patch(
                baseUrl +
                "update-attendance/" +
                attendance.id +
                "/",
                {
                    owner_verified: true,
                    owner_verified_time: new Date().toISOString()
                }
            );
            // 2. Get assignment
            const assignmentRes = await axios.get(
                baseUrl + "update-assignment/" + attendance.assignment.id + "/"
            );
            const assignment = assignmentRes.data;
            // 3. Update totals
            await axios.patch(
                baseUrl +
                "update-assignment/" +
                attendance.assignment.id +
                "/",
                {
                    total_present_days:
                        Number(assignment.total_present_days) + 1,
                    total_amount:
                        Number(assignment.total_amount) +
                        Number(assignment.worker.cost)
                }
            )
            Swal.fire(
                "Success",
                "Attendance Verified",
                "success"
            );
            await fetchAttendance(
                selectedRequirement.id
            );
        } catch (err) {
            console.log(err);
            Swal.fire(
                "Error",
                "Verification Failed",
                "error"
            );
        }
    };
    const handleRequirementClick = async (req) => {
        setSelectedRequirement(req);
        await fetchAttendance(req.id);
        setShowAttendanceModal(true);
    };
    return (
        <section className="container mt-4">

            <div className="page-header">

                <h3>
                    Attendance Verification
                </h3>

                <small>
                    Verify worker attendance records
                </small>

            </div>

            <div className="row">

                {requirements.length === 0 && (
                    <div className="alert alert-warning">
                        No Requirements Found
                    </div>
                )}

                {requirements.map((req) => (
                    <div
                        className="col-lg-3 col-md-4 col-sm-6 mb-4"
                        key={req.id}
                    >

                        <div
                            className="card app-card"
                            style={{cursor: "pointer"}}
                            onClick={() =>
                                handleRequirementClick(req)
                            }
                        >

                            <div className="app-card-header">

                                🌱 {req.crop_type}

                            </div>

                            <div className="app-card-body">

                                <p>
                                    <strong>Location:</strong>
                                    {" "}
                                    {req.location}
                                </p>

                                <p>
                                    <strong>Pincode:</strong>
                                    {" "}
                                    {req.pincode}
                                </p>

                                <p>
                                    <strong>Budget:</strong>
                                    {" "}
                                    ₹{req.budget}
                                </p>

                                <p>
                                    <strong>Date:</strong>
                                    {" "}
                                    {req.required_date}
                                </p>

                            </div>

                            <div className="app-card-footer">

                                <button
                                    className="btn btn-action w-100"
                                >
                                    📋 View Attendance
                                </button>

                            </div>

                        </div>

                    </div>
                ))}

            </div>

            {/* ATTENDANCE MODAL */}

            {showAttendanceModal && (
                <div
                    className="modal fade show app-modal"
                    style={{
                        display: "block",
                        backgroundColor:
                            "rgba(0,0,0,.5)"
                    }}
                >

                    <div
                        className="modal-dialog modal-xl modal-dialog-centered"
                    >

                        <div className="modal-content">

                            <div className="modal-header">

                                <h5 className="modal-title">

                                    Attendance Records -
                                    {" "}
                                    {selectedRequirement?.crop_type}

                                </h5>

                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() =>
                                        setShowAttendanceModal(false)
                                    }
                                />

                            </div>

                            <div
                                className="modal-body"
                                style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto"
                                }}
                            >

                                {attendance.length === 0 && (
                                    <div className="alert alert-warning">

                                        No Attendance Records Found

                                    </div>
                                )}

                                <div className="row">

                                    {attendance.map((item) => (
                                        <div
                                            className="col-lg-4 col-md-6 mb-4"
                                            key={item.id}
                                        >

                                            <div className="card app-card">

                                                <div className="app-card-header">

                                                    👨‍🌾
                                                    {" "}
                                                    {
                                                        item.assignment.worker.name
                                                    }

                                                </div>

                                                <div className="app-card-body">

                                                    <p>

                                                        <strong>
                                                            Date:
                                                        </strong>
                                                        {" "}
                                                        {
                                                            item.attendance_date
                                                        }

                                                    </p>

                                                    <p>

                                                        <strong>
                                                            Worker Marked:
                                                        </strong>
                                                        {" "}

                                                        {item.worker_marked
                                                            ? "✅ YES"
                                                            : "❌ NO"}

                                                    </p>

                                                    <p>

                                                        <strong>
                                                            Status:
                                                        </strong>
                                                        {" "}

                                                        {item.owner_verified
                                                            ? "✅ VERIFIED"
                                                            : "⏳ PENDING"}

                                                    </p>

                                                </div>

                                                <div className="app-card-footer">

                                                    {!item.owner_verified ? (
                                                        <button
                                                            className="btn btn-success-action w-100"
                                                            onClick={() =>
                                                                verifyAttendance(item)
                                                            }
                                                        >
                                                            ✅ Verify Attendance
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn btn-secondary w-100"
                                                            disabled
                                                        >
                                                            Verified
                                                        </button>
                                                    )}

                                                </div>

                                            </div>

                                        </div>
                                    ))}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            )}

        </section>
    );
}
export default OwnerAttendanceVerification;